import React from 'react';
import View from './view'
import "./login.css";
import Page from 'src/components/Page';
function index(props) {
    return (
        <Page title="Login | Leon Gallery Premier Art Auction House in the Philippines" >
            <View/>
        </Page>
    );
}

export default index;